import { Heart } from "lucide-react";

const inputCls =
    "w-full h-12 rounded-xl border border-border bg-white px-4 text-brand-navy placeholder:text-muted-foreground/60 focus:outline-none focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all";

const Field = ({ label, children, className = "" }) => (
    <div className={className}>
        <label className="block text-sm font-semibold text-brand-navy mb-2">{label}</label>
        {children}
    </div>
);

export const VolunteerSuccess = ({ onReset }) => (
    <div className="mt-10 rounded-3xl bg-brand-green-light border border-brand-green/30 p-10 text-center" data-testid="volunteer-success">
        <div className="h-16 w-16 rounded-full bg-brand-green text-white flex items-center justify-center mx-auto">
            <Heart size={28} className="fill-white" />
        </div>
        <h3 className="mt-5 font-display font-bold text-2xl text-brand-navy">
            ¡Bienvenido(a) a la familia Formar Estructura!
        </h3>
        <p className="mt-3 text-muted-foreground">
            Tu inscripción fue recibida. Pronto te contactaremos al correo que registraste.
        </p>
        <button type="button" onClick={onReset} className="btn-ghost-pill mt-6" data-testid="volunteer-new-submission">
            Enviar otra inscripción
        </button>
    </div>
);

export const VolunteerForm = ({ form, set, toggleArea, loading, onSubmit, areas, availability }) => (
    <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="volunteer-form">
        <div className="grid sm:grid-cols-2 gap-5">
            <Field label="Nombres *">
                <input data-testid="volunteer-input-nombres" value={form.nombres} onChange={(e) => set("nombres", e.target.value)} className={inputCls} required />
            </Field>
            <Field label="Apellidos *">
                <input data-testid="volunteer-input-apellidos" value={form.apellidos} onChange={(e) => set("apellidos", e.target.value)} className={inputCls} required />
            </Field>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
            <Field label="Correo electrónico *">
                <input type="email" data-testid="volunteer-input-email" value={form.email} onChange={(e) => set("email", e.target.value)} className={inputCls} required />
            </Field>
            <Field label="Teléfono *">
                <input data-testid="volunteer-input-telefono" value={form.telefono} onChange={(e) => set("telefono", e.target.value)} className={inputCls} required />
            </Field>
        </div>
        <div className="grid sm:grid-cols-3 gap-5">
            <Field label="Edad *">
                <input type="number" min="14" max="100" data-testid="volunteer-input-edad" value={form.edad} onChange={(e) => set("edad", e.target.value)} className={inputCls} required />
            </Field>
            <Field label="Ciudad / país *" className="sm:col-span-2">
                <input data-testid="volunteer-input-ciudad" value={form.ciudad} onChange={(e) => set("ciudad", e.target.value)} className={inputCls} placeholder="Ej. Ibagué, Colombia" required />
            </Field>
        </div>
        <Field label="Profesión u ocupación">
            <input data-testid="volunteer-input-profesion" value={form.profesion} onChange={(e) => set("profesion", e.target.value)} className={inputCls} />
        </Field>

        <Field label="Áreas de interés *">
            <div className="grid sm:grid-cols-2 gap-2 mt-2">
                {areas.map((a) => {
                    const active = form.areas_interes.includes(a);
                    return (
                        <label
                            key={a}
                            className={`cursor-pointer rounded-xl border-2 px-4 py-3 text-sm transition-colors ${
                                active
                                    ? "border-brand-green bg-brand-green-light text-brand-navy font-semibold"
                                    : "border-border hover:border-brand-green/50 text-muted-foreground"
                            }`}
                        >
                            <input
                                type="checkbox"
                                className="sr-only"
                                data-testid={`volunteer-area-${a}`}
                                checked={active}
                                onChange={() => toggleArea(a)}
                            />
                            {a}
                        </label>
                    );
                })}
            </div>
        </Field>

        <Field label="Disponibilidad *">
            <select
                data-testid="volunteer-select-disponibilidad"
                value={form.disponibilidad}
                onChange={(e) => set("disponibilidad", e.target.value)}
                className={inputCls}
                required
            >
                <option value="">Selecciona una opción</option>
                {availability.map((o) => (
                    <option key={o} value={o}>{o}</option>
                ))}
            </select>
        </Field>

        <Field label="Experiencia previa (opcional)">
            <textarea
                data-testid="volunteer-input-experiencia"
                value={form.experiencia}
                onChange={(e) => set("experiencia", e.target.value)}
                className={`${inputCls} min-h-[100px]`}
                rows={4}
            />
        </Field>

        <Field label="¿Qué te motiva a ser voluntario? *">
            <textarea
                data-testid="volunteer-input-motivacion"
                value={form.motivacion}
                onChange={(e) => set("motivacion", e.target.value)}
                className={`${inputCls} min-h-[120px]`}
                rows={5}
                required
            />
        </Field>

        <button
            type="submit"
            disabled={loading}
            className="btn-primary-pill w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="volunteer-submit-button"
        >
            {loading ? "Enviando..." : "Enviar inscripción"}
        </button>
    </form>
);
